<form [formGroup]="orderForm">
  <vnm-validation-errors [errors]="errors"></vnm-validation-errors>
  <vnm-tile-card header="checkout-order.billing-address">
    <vnm-address-form [addressRequired]="true" formControlName="billingAddress"></vnm-address-form>
  </vnm-tile-card>
  <ng-container *ngIf="shoppingCart.requiresShipping">
    <vnm-tile-card header="shipping-information.header">
      <vnm-shipping-information-form formControlName="shippingInformation" @fade></vnm-shipping-information-form>
    </vnm-tile-card>
    <vnm-tile-card header="order-address.header.shipping">
      <vnm-form-option label="checkout-order.same-address">
        <p-inputSwitch
          [(ngModel)]="sameAddress"
          [ngModelOptions]="{ standalone: true }"
          (onChange)="onToggleShipping($event)"
        ></p-inputSwitch>
      </vnm-form-option>
      <vnm-address-form formControlName="shippingAddress" @fade [addressRequired]="true"></vnm-address-form>
    </vnm-tile-card>
  </ng-container>
</form>
